import {useState} from 'react'
import {TreatmentRequestNewFollowUp} from '@/features/treatment-requests/components/treatment-request-new-follow-up/TreatmentRequestNewFollowUp'
import {TreatmentRequestExtended} from '@/features/treatment-requests/types'
import {TreatmentRequestFollowUpItem} from '@/features/treatment-requests/components/treatment-request-follow-up-item/TreatmentRequestFollowUpItem'
import {useTranslation} from 'react-i18next'
import {
    StyledEmptyFollowUpsLabel,
    StyledFollowUpsScrollArea,
    StyledTreatmentRequestFollowUpsContent,
    StyledTreatmentRequestFollowUpsTop
} from './style'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'

export const TreatmentRequestFollowUps = ({followUps}: {followUps: TreatmentRequestExtended['followups']}) => {
    const {t} = useTranslation()
    const [hiddenElements, setHiddenElements] = useState(false)
    const [disabledItems, setDisabledItems] = useState(false)

    return (
        <>
            <StyledTreatmentRequestFollowUpsTop direction="column" gap={3} fullWidth>
                {followUps.length == 0 && !hiddenElements && (
                    <StyledEmptyFollowUpsLabel>{t('treatment_requests:no_follow_up')}</StyledEmptyFollowUpsLabel>
                )}

                {!disabledItems && (
                    <TreatmentRequestNewFollowUp
                        buttonPosition={followUps.length > 0 ? 'end' : 'start'}
                        onToggleNewFollowUp={value => setHiddenElements(value)}
                    />
                )}
            </StyledTreatmentRequestFollowUpsTop>

            <StyledFollowUpsScrollArea scrollbar={<Scrollbar />}>
                {followUps.length > 0 && !hiddenElements && (
                    <StyledTreatmentRequestFollowUpsContent direction="column" gap={3}>
                        {followUps.map((followUp, index) => (
                            <TreatmentRequestFollowUpItem
                                followUp={followUp}
                                isDisabled={disabledItems}
                                onToggleEditFollowUp={value => setDisabledItems(value)}
                                number={followUps.length - index}
                                key={followUp.id}
                                isLast={index == 0}
                            />
                        ))}
                    </StyledTreatmentRequestFollowUpsContent>
                )}
            </StyledFollowUpsScrollArea>
        </>
    )
}
